export default __webpack_public_path__ + "static/media/confetti.dd907fc8.gif";